const WebNotifications = {};

WebNotifications.subscribe = function() {
  if (window.App.cable) {
    window.App.cable.subscriptions.create('WebNotificationsChannel', {
      received: function(data) {
        var a = '<a href="' + data.url + '" class="text-white underline">' + data.message;
        $('body').trigger('flashmessage', ['notice', a]);
      }
    });
  }
};

export default WebNotifications;
